import React from 'react';
import { Box, Button, Card, Tooltip, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import LockIcon from '@mui/icons-material/Lock';

const AppCard = ({ item }) => (
  <Card
    sx={{
    p: 2.5,
    background: '#7d7561',
    boxShadow: '0 2px 2px rgba(0,0,0,.25)',
    borderRadius: 1,
    color: '#fff',
    position: 'relative',
    cursor: item?.access ? 'pointer' : 'not-allowed',
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  }}
    onClick={(e) => item?.access ? window.open(item?.url, '_blank') : e.preventDefault() }
  >
    {!item?.access && (
      <Tooltip title="Restricted Access" arrow>
        <LockIcon fontSize="small" sx={{color: "#134067", position: "absolute", top: 8, right: 10,}} />
      </Tooltip>
    )}
    <Typography className="app-title flex-centered" sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 1 }}>
      <img src={item?.logo} alt={item?.label} style={{ maxHeight: 30, marginRight: '15px' }} />
      <h4 style={{ margin: 0, fontSize: '18px', fontWeight: 500, fontFamily: "Roboto-Regular" }}>
        {item?.label} {item?.isBeta && <sup>Beta</sup>}
      </h4>
    </Typography>
     <Typography sx={{margin:'15px 0', fontFamily: "Roboto-Regular", height:'100px', overflow:'auto', fontSize:'14px', lineHeight: "25px", '&::-webkit-scrollbar':{width:'8px'}, '&::-webkit-scrollbar-track':{backgroundColor:'#7d7561'}, '&::-webkit-scrollbar-thumb:hover':{backgroundColor:'#aaa'} }} >
    {item?.description}
    </Typography>
    <Box>
    {!item?.access ? (
      <span className="no-access-content" style={{ fontSize: "12px", color: "#fff03b" }}>
        Please contact support@sparta.aero to access this application
      </span>
    ) : (
      <Button size="small" endIcon={<ChevronRightIcon fontSize="small" />} sx={{ color: '#fff' }}>
        Access
      </Button>
    )}
    </Box>
  </Card>
);

export default AppCard;
